import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IncentivesTransitionComponent } from './components/incentives-transition/incentives-transition.component';
import { IncentivesReportsComponent } from './components/incentives-reports/incentives-reports.component';
import { IncentivesCompensafeComponent } from './components/incentives-compensafe/incentives-compensafe.component';
import { IncentivesInsightsComponent } from './components/incentives-insights/incentives-insights.component';
import { IncentivesUpgradeComponent } from './components/incentives-upgrade/incentives-upgrade.component';
import { VolumeEstimatorComponent } from './components/volume-estimator/volume-estimator.component';
import { IncentivesInsightOptionComponent } from './components/incentives-insight-option/incentives-insight-option.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { IncentivesInsightProfitabilityComponent } from './components/incentives-insight-profitability/incentives-insight-profitability.component';
import { IncentivesInsightsRevenueTrendsComponent } from './components/incentives-insights-revenue-trends/incentives-insights-revenue-trends.component';
import { FinancialsAtAGlanceComponent } from './components/financials-at-a-glance/financials-at-a-glance.component';
import { IncentivesComponent } from './components/financials-insight-incentives/financials-insight-incentives.component';
import { FinancialsInsightCompSnapshotComponent } from './financials-insight-comp-snapshot/financials-insight-comp-snapshot.component';

const incentivesRoutes: Routes = [
    { path: '', component: IncentivesTransitionComponent },
    {
        path: 'at-a-glance',
        component: FinancialsAtAGlanceComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'reports',
        component: IncentivesReportsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights',
        component: IncentivesInsightsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'compensafe',
        component: IncentivesCompensafeComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'upgrade', component: IncentivesUpgradeComponent },
    {
        path: 'comm-calculator',
        component: VolumeEstimatorComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/option',
        component: IncentivesInsightOptionComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/profitability',
        component: IncentivesInsightProfitabilityComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/revenue-trends',
        component: IncentivesInsightsRevenueTrendsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/incentives',
        component: IncentivesComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/comp-snapshot',
        component: FinancialsInsightCompSnapshotComponent,
        canActivate: [AuthGuardService],
    },
];

@NgModule({
    imports: [RouterModule.forChild(incentivesRoutes)],
    exports: [RouterModule],
})
export class IncentivesRoutingModule {}
